<template>
  <v-layout column class="inner-pages">
    <Header  />

    <v-flex class="sfh-login-form background-image text-xs-center signup-page scrollbar scroll-style-15  px-5 pt-5" >
      <v-layout row wrap align-center >
        <v-flex xs12 class="text-xs-left pb-4 ">
          <p>Hello, <strong>{{user.firstName}} {{user.lastName}}</strong>! <br>Please pay the license fee to complete the
            registration. You'll get all levels and features, as well as unlimited exam attempts.</p>
        </v-flex>
        <v-flex xs12 text-xs-right v-if="priceDiscount && this.coupon">
          <div style="display: inline-flex;">Regular Price: <div class="font-weight-bold" style="width:50px;">${{price.toFixed(2)}}</div></div>
          <br>
          <div style="display: inline-flex;">Coupon applied <span>({{this.coupon}})</span>: <div class="font-weight-bold" style="width:50px;">-${{priceDiscount.toFixed(2)}}</div></div>
          <br>
          <div style="display: inline-flex;">______________________________</div>
          <br>
          <div style="display: inline-flex;">Discounted Price: <div class="font-weight-bold" style="width:50px;">${{ effectivePrice.toFixed(2) }}</div></div>
          <br>
          <div style="display: inline-flex;">______________________________</div>
        </v-flex>
        <v-flex xs12 >
          <v-layout v-if="btTokenGenerated && licenseClientToken!== 0 && memberId !== 0">
            <license-payment
              name="test12"
              page="quick-payment"
              :isBackBtn="false"
              :token="licenseClientToken" :paypal="true" :userId="user.id" orderId="SFHTier1"
              :memberId="memberId" :selectedCouponId="selectedCouponId" :amount="effectivePrice">
            </license-payment>
          </v-layout>
          <v-layout v-else>
            <v-flex class="subheading primary--text font-weight-bold">Loading secure payment gateway...</v-flex>
          </v-layout>
        </v-flex>
        <coupon-banner/>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import Header from '../../layouts/Header'
import crypto from '@/mixins/crypto'
import common from '@/mixins/common'
import { mapGetters, mapMutations } from 'vuex'
import CouponBanner from '../widgets/CouponBanner'
import LicensePayment from '../widgets/LicensePayment'

export default {
  name: 'QuickPayment',
  components: {CouponBanner, LicensePayment, Header},
  data () {
    return {
      appId: process.env.GAME_ID,
      otp: '',
      btTokenGenerated: false,
      userId: 0,
      memberId: 0,
      selectedCouponId: 0,
      price: 0,
      priceDiscount: 0,
      effectivePrice: 0,
      creationLoaderDialog: false,
      switchAccountDialog: false,
      registerLoading: true,
      userFullName: '',
      loading: false,
      changedEmail: false,
      accountExistsDialog: false,
      apiUrl: process.env.API_URL,
      appName: process.env.APP_NAME,
      fName: '',
      lName: '',
      email: '',
      coupon: '',
      errorMsg: '',
      isLoader: false
    }
  },
  props: {
    page: {
      default: 'SignUp',
      type: String
    }
  },
  computed: {
    user () {
      return this.$store.getters['user/getUserDetails']
    },
    inputClassEmail () {
      return this.errorMsg !== '' ? 'validate invalid' : this.email !== '' ? 'validate valid' : ''
    },
    ...mapGetters('registration', ['getUserDetails']),
    licenseClientToken () {
      return this.$store.getters['braintree/getClientToken']
    }
  },
  created () {
    this.getStarted()
    if (!this.$route.query.coupon) {
      this.couponByTag()
    }
  },
  methods: {
    ...mapMutations('registration', [
      'setUser'
    ]),
    couponByTag () {
      this.$http({
        url: this.apiUrl + `/ws/userservice/coupons/course/${process.env.GAME_ID}?tags=ALL`,
        method: 'GET'
      }).then(res => {
        if (res.status === 200) {
          this.$router.push({name: 'QuickPayment', query: {coupon: res.data.code}})
          window.location.reload()
        }
      }).catch((e) => {
        console.log('Caught', e)
      })
    },
    getStarted () {
      if (this.user.id) {
        this.coupon = this.$route.query.coupon
        if (this.coupon) {
          this.getCouponDetails(this.coupon)
        } else {
          this.getCoursePrice()
        }
        this.fetchBtToken(this.user.id)
        this.getMemberAndGroupId()
      }
    },
    getCouponDetails (coupon) {
      this.$http({
        url: process.env.API_URL + `/ws/userservice/coupons/${coupon}`,
        method: 'GET'
      }).then((data) => {
        this.selectedCouponId = data.data.couponId
        this.getCoursePrice(data.data.discount)
      }, (err) => {
        console.log('error found', err)
        this.$store.commit('flashError', 'Invalid coupon', { root: true })
        this.getCoursePrice()
      }).catch((e) => {
        console.log('Caught', e)
        this.$store.commit('flashError', e.message, { root: true })
      })
    },
    getDiscountedPrice (price, discount) {
      return parseFloat((price - ((price * discount) / 100)))
    },
    getCoursePrice (discount = 0) {
      this.$http({
        url: this.apiUrl + `/ws/playerservice/program/${this.appId}/cost`,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + this.$auth.token()
        }
      }).then((res) => {
        this.price = res.data.cost
        if (discount) {
          this.effectivePrice = this.getDiscountedPrice(res.data.cost, discount)
          this.priceDiscount = ((res.data.cost * discount) / 100)
        } else {
          this.effectivePrice = res.data.cost
        }
      }, (err) => {
        console.log('error found', err)
      }).catch((e) => {
        console.log('Caught', e)
      })
    },
    currentGroup (groups, courseId) {
      const filteredGroups = groups.reduce((a, b) => {
        const deck = b.decks.find(deck => deck.regId === courseId)
        if (deck) {
          return [...a, b]
        }
        return a
      }, [])
      return filteredGroups[0]
    },
    getMemberAndGroupId () {
      this.$http({
        url: process.env.API_URL + '/ws/playerservice/groups/user/' + this.user.id,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + this.$auth.token()
        }
      }).then((res) => {
        const groups = this.currentGroup(res.data.groups, +process.env.GAME_ID)
        this.memberId = groups.memberId
        this.btTokenGenerated = true
      })
    },
    fetchBtToken (userId) {
      this.$store.dispatch('braintree/purchaseLicense', userId)
    },
    jsonToQueryString (json) {
      return '' +
        Object.keys(json).map(function (key) {
          return encodeURIComponent(key) + '=' +
            encodeURIComponent(json[key])
        }).join('&')
    }
    // login () {
    //   console.log('registerSfh: in login')
    //   this.loading = true
    //   let parameters = {
    //     grant_type: 'password',
    //     client_id: process.env.CLIENT_ID,
    //     client_secret: process.env.CLIENT_SECRET,
    //     username: this.email,
    //     password: this.email
    //   }
    //   this.$auth.login({
    //     headers: {
    //     },
    //     data: this.jsonToQueryString(parameters),
    //     rememberMe: this.rememberMe,
    //     success (res) {
    //       // eslint-disable-next-line no-console
    //       console.log('Login res', res)
    //       this.loginLoader = false
    //       this.$store.commit('setAuthToken', this.$auth.token())
    //       document.cookie = 'auth_token=' + this.$auth.token() + ';domain=cogneti.com'
    //       this.$store.commit('user/resetUser', '')
    //       // /////////////////
    //       // this.userId = 13385
    //       // this.memberId = 13993
    //       // this.selectedCouponId = 0
    //       // this.effectivePrice = 15
    //       // this.fetchBtToken(this.userId)
    //       // this.$store.dispatch('course/fetchAvailablePrograms')
    //       // setTimeout(() => {
    //       //   this.btTokenGenerated = true
    //       // }, 5000)
    //       this.me()
    //     },
    //     error (err) {
    //       console.log('Error Occur:' + err)
    //       this.errors.add({
    //         scope: 'slot1',
    //         field: 'password',
    //         msg: 'Invalid username or password'
    //       })
    //       this.loading = false
    //       this.loginLoader = false
    //     }
    //   })
    // },
    // me () {
    //   const username = this.email
    //   const url = process.env.GAME_ID === 52 ? `${this.apiUrl}/ws/playerservice/user/${username}` : `${this.apiUrl}/ws/playerservice/user/${username}?deck=${process.env.GAME_ID}`
    //   this.$http({
    //     url,
    //     method: 'GET',
    //     headers: {
    //       Authorization: 'Bearer ' + this.$auth.token()
    //     }
    //   }).then((res) => {
    //     this.userId = res.data.id
    //     this.setUser({
    //       ...this.getUserDetails,
    //       userId: res.data.id})
    //     this.$store.dispatch('course/fetchAvailablePrograms')
    //   })
    // },
    // registerSfh (fName = null, lName = null, password = null) {
    //   // eslint-disable-next-line no-console
    //   console.log('registerSfh')
    //   // COPY OF 52 GetNameAndPwd
    //   this.creationLoaderDialog = true
    //   this.$store.commit('setLoadingDialog', true, { root: true })
    //   this.$http({
    //     url: process.env.API_URL + '/ws/userservice/course/52/register',
    //     method: 'POST',
    //     data: {
    //       'firstName': fName,
    //       'lastName': lName,
    //       'password': password,
    //       'email': this.email,
    //       'client': null,
    //       'otpId': null,
    //       'country': 233,
    //       'state': 1398,
    //       'app': null,
    //       'platform': null
    //     }
    //   }).then(() => {
    //     this.$store.commit('setLoadingDialog', false, { root: true })
    //     console.log('registerSfh: before login')
    //     this.login()
    //   }, error => {
    //     this.$store.commit('setLoadingDialog', false, { root: true })
    //     this.$store.commit('flashError', error.message, { root: true })
    //   }).catch(error => {
    //     this.$store.commit('setLoadingDialog', false, { root: true })
    //     this.$store.commit('flashError', error.message, { root: true })
    //   })
    // },
    // confirmMyEmail () {
    //   this.loading = true
    //   this.errors.clear('slot1')
    //   this.$store.dispatch('registration/sendOtp', this.email)
    //     .then((res) => {
    //       // console.log(res)
    //       if (res.userState && (res.userState === 2 || res.userState === 1)) {
    //         this.fName = res.firstName
    //         this.lName = res.lastName
    //         if (res.userState === 1) {
    //           this.switchAccountDialog = true
    //           this.loading = true
    //           this.userFullName = res.firstName + ' ' + res.lastName
    //           this.email = res.email
    //         } else {
    //           this.accountExistsDialog = true
    //         }
    //       } else {
    //         console.log('Response:', res)
    //         this.setUser({
    //           ...this.getUserDetails,
    //           email: this.encryptData(this.email),
    //           email_otp_generated: true,
    //           email_otp_id: res.data.otpId})
    //         // this.$router.push({name: 'SignUp',
    //         //   params: {step: 'code-verification', otp_id: res.data.otpId}})
    //       }
    //       this.loading = false
    //     }, (err) => {
    //       this.loading = false
    //       this.errorMsg = 'Invalid email address.'
    //       this.errors.add({
    //         scope: 'slot1',
    //         field: 'email',
    //         msg: 'Invalid email address'
    //       })
    //       console.log('error found', err)
    //     }).catch((e) => {
    //       this.loading = false
    //       console.log('Caught', e)
    //     })
    // }
  },
  watch: {
    user () {
      this.getStarted()
    }
  },
  mixins: [crypto, common]
}
</script>



// WEBPACK FOOTER //
// src/components/views/user-quick-sign-up/QuickPayment.vue